import { render, staticRenderFns } from "./DataDictionary.vue?vue&type=template&id=badbdf82&scoped=true"
import script from "./DataDictionary.vue?vue&type=script&lang=js"
export * from "./DataDictionary.vue?vue&type=script&lang=js"
import style0 from "./DataDictionary.vue?vue&type=style&index=0&id=badbdf82&prod&lang=stylus&scoped=true"
import style1 from "./DataDictionary.vue?vue&type=style&index=1&id=badbdf82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badbdf82",
  null
  
)

export default component.exports